import { openIntercomMessenger } from '@stores/Intercom';
import { ReactNode } from 'react';
import css from './ContactUsLink.module.scss';

/**
 * Inline "Contact us" link that opens the Intercom messenger (composer
 * prefilled when `message` is given). Styled as a text link but is a real
 * <button> for accessibility. Used in the over-10-hour-limit messaging
 * (upload pill, toast, picker status tooltip).
 */
export const ContactUsLink = ({
  children = 'Contact us',
  message,
}: {
  children?: ReactNode;
  message?: string;
}) => (
  <button
    type="button"
    className={css.contactUsLink}
    onClick={() => openIntercomMessenger(message)}
  >
    {children}
  </button>
);
